module.exports = __webpack_public_path__ + "img/img-2.ae67a74f.png";